import React, { useEffect, useState } from "react";
import CoreFilterButtonIcon from "../../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import StudioFilter from "../../../../app/core/components/UserFilter/StudioFilter";
import UserFilter from "../../../../app/core/components/UserFilter/UserFilter";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { t } from "i18next";
import { Button, Popover } from "@mui/material";
import { ROLE } from "../../../../utils/constants/profiles";
import { useSelector } from "react-redux";

const FilterDocument = ({
  dataStudio,
  dataOperators,
  dataUsers,
  filter,
  setFilter,
  setDebouncedInputStudioValue,
  setDebouncedInputOperatorValue,
  setDebouncedInputUserValue,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStudio, setSelectedStudio] = useState();
  const [selectedOperator, setSelectedOperator] = useState();
  const [user, setUser] = useState();

  const role = useSelector((state) => state.app.role);

  useEffect(() => {
    if (selectedStudio?.id)
      setFilter({
        ...filter,
        studioId: selectedStudio?.id,
      });
    else
      setFilter({
        ...filter,
        studioId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStudio?.id]);

  useEffect(() => {
    if (selectedOperator?.id)
      setFilter({
        ...filter,
        adminId: selectedOperator?.id,
      });
    else
      setFilter({
        ...filter,
        adminId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperator?.id]);

  useEffect(() => {
    if (user?.id)
      setFilter({
        ...filter,
        userId: user?.id,
      });
    else
      setFilter({
        ...filter,
        userId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    setFilter({
      adminId: "",
      studioId: "",
    });
  };

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { borderRadius: "8px", marginTop: "5px", overflow: "visible" },
        }}
      >
        <div className="w-[25rem] p-4">
          <form className="flex flex-col gap-4">
            {ROLE.ADMIN === role && (
              <div className="flex flex-col">
                <h3 className="m-2 ">{t("Studio")}</h3>
                <StudioFilter
                  selectedUser={selectedStudio}
                  setSelectedUser={(e) => setSelectedStudio(e)}
                  usersList={dataStudio?.Data?.items}
                  setDebouncedInputUserValue={setDebouncedInputStudioValue}
                  startAdornment={<SearchRoundedIcon size={20} />}
                />
              </div>
            )}

            <div className="flex flex-col">
              <h2 className="m-2 text-lg">{t("Operator")}</h2>
              <UserFilter
                selectedUser={selectedOperator}
                setSelectedUser={(e) => {
                  setSelectedOperator(e);
                }}
                usersList={dataOperators?.Data?.items}
                setDebouncedInputUserValue={setDebouncedInputOperatorValue}
                externalLabel={t("BriefSearchOperator")}
                startAdornment={<SearchRoundedIcon size={20} />}
              />
            </div>

            <div className="flex flex-col">
              <h2 className="m-2 text-lg">{t("Users")}</h2>
              <UserFilter
                selectedUser={user}
                setSelectedUser={setUser}
                usersList={dataUsers?.Data?.items}
                setDebouncedInputUserValue={setDebouncedInputUserValue}
                // isUsersLoading={isUsersSelectLoading || isUsersSelectFetching}
              />
            </div>

            <div className="flex space-x-4 mt-4 justify-center">
              <Button
                className="bg-red-700 text-white w-full"
                sx={{ marginTop: "16px" }}
                onClick={handleReset}
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default FilterDocument;
